import { setWorkerUrl } from 'maplibre-gl';
import maplibreWorkerUrl from 'maplibre-gl/dist/maplibre-gl-worker.mjs?worker&url';

// MapLibre 6 resolves its default worker relative to the final application
// chunk. Vite does not discover that runtime-only URL, so production otherwise
// requests /assets/maplibre-gl-worker.mjs without ever emitting that file. An
// explicit ?worker&url import makes Vite bundle the worker and its shared
// module, then fingerprint the result. setWorkerUrl points every MapLibre map
// at that emitted asset before maps mount.
setWorkerUrl(maplibreWorkerUrl);

export { maplibreWorkerUrl };
